import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromCabinet from './cabinet.reducer';
import { selectUser } from '../account/account.selectors';

export const selectCabinetState = createFeatureSelector<fromCabinet.CabinetState>(fromCabinet.cabinetsFeatureKey);

export const selectAllCabinets = createSelector(
  selectCabinetState,
  fromCabinet.selectAll
);

export const selectCabinetEntities = createSelector(
  selectCabinetState,
  fromCabinet.selectEntities
);

export const selectCabinetById = (id: string) => createSelector(
  selectCabinetEntities,
  cabinetEntities => cabinetEntities[id] || null
);

export const selectCabinet = createSelector(
  selectCabinetEntities,
  selectUser,
  (cabinetEntities, user) => user?.uid ? cabinetEntities[user.uid] : null
);

export const selectCabinetId = createSelector(
  selectCabinet,
  cabinet => cabinet?.id || null
);
